import React from 'react'
import axios from 'axios'
import Slider from "react-slick";
import './active.css'
import Bannner from '../../static/images/banner.png'
class MemberActive extends React.Component{
	constructor(props){
		super(props)
		this.state={
      			getActives:'',
      			visible:false,
      			title:''
   		}
	}
	componentDidMount(){
    
    		this.getActives()
    
  	} 
  	getActives(){
     		const _this = this
     		axios.get('fapi/getActives?count=4')

      		.then(res=>{
      			
        		_this.setState({
            		getActives:res.data
            		
        		})  
        
    		})   
  	}
	render(){
		const activesData = this.state.getActives
		

		const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			autoplay: false,
			autoplaySpeed: 2000,
			slidesToScroll: 1,
			arrows: false,
			appendDots: dots => ( <
				div style = {
					{
					
					}
				} >
				<
				ul style = {
					{
						margin: "0px"
					}
				} > {
					dots
				} < /ul> <
				/div>
			),
			customPaging: i => ( 

				<div style={{
					"background":"url("+(activesData.imghost+activesData.data[i].roll_thumb_url)+") left center",
					"backgroundRepeat":'no-repeat'
				}}>{activesData.data[i].title_s}</div>
			)
			
	    };
    return (

      <div className="active-box">
        
        <Slider {...settings}>
		{
			 activesData.data?activesData.data.map((item,i) =>{
			 	const data = activesData.imghost +item.roll_url
            	return <div key={i} className="act-detail"><a href={item.linkurl} target="_blank"><img src={data} /></a></div>
             }):null
		}
        </Slider>
      </div>
    );


	}
}

export default MemberActive



// WEBPACK FOOTER //
// ./src/component/member-active/active.js